import { escapeAttr } from './format.js';

export interface LazyImageOptions {
  alt?: string;
  className?: string;
  loading?: 'lazy' | 'eager';
}

export function lazyImageHtml(src: string, opts: LazyImageOptions = {}): string {
  const url = String(src || '').trim();
  if (!url) return '';
  const alt = escapeAttr(opts.alt || '');
  const loading = opts.loading === 'eager' ? 'eager' : 'lazy';
  const extra = opts.className ? ' ' + escapeAttr(opts.className) : '';
  return (
    '<span class="img-shimmer-wrap">' +
    '<img src="' +
    escapeAttr(url) +
    '" alt="' +
    alt +
    '" loading="' +
    loading +
    '" decoding="async" class="img-shimmer-target' +
    extra +
    '" />' +
    '</span>'
  );
}

function markWrap(img: HTMLImageElement): void {
  const wrap = img.closest('.img-shimmer-wrap');
  if (!wrap) return;
  if (img.complete && img.naturalWidth > 0) {
    wrap.classList.add('is-loaded');
    wrap.classList.remove('is-error');
  } else if (img.complete) {
    wrap.classList.add('is-error');
    wrap.classList.remove('is-loaded');
  }
}

export function refreshLazyImages(root: ParentNode = document): void {
  root.querySelectorAll<HTMLImageElement>('.img-shimmer-target').forEach(markWrap);
}

let initDone = false;

export function initLazyImages(): void {
  if (initDone) return;
  initDone = true;
  document.addEventListener(
    'load',
    (e) => {
      const t = e.target;
      if (!(t instanceof HTMLImageElement)) return;
      if (!t.classList.contains('img-shimmer-target')) return;
      const wrap = t.closest('.img-shimmer-wrap');
      if (!wrap) return;
      wrap.classList.add('is-loaded');
      wrap.classList.remove('is-error');
    },
    true
  );
  document.addEventListener(
    'error',
    (e) => {
      const t = e.target;
      if (!(t instanceof HTMLImageElement)) return;
      if (!t.classList.contains('img-shimmer-target')) return;
      const wrap = t.closest('.img-shimmer-wrap');
      if (!wrap) return;
      wrap.classList.add('is-error');
      wrap.classList.remove('is-loaded');
    },
    true
  );
  refreshLazyImages();
}
